export default "__VITE_ASSET__CBib_8gI__"